import { useMutation, useQueryClient } from "@tanstack/react-query";
import { refreshTerminalList } from "../../../services/accountService";

export default function useRefreshTerminalListMutation(
  accountHolderCode: string
) {
  const queryClient = useQueryClient();

  return useMutation<string, string, string>(
    () => refreshTerminalList(accountHolderCode),
    {
      onSuccess() {
        queryClient.invalidateQueries(["accountConfig", accountHolderCode]);
      },
    }
  );
}
